import { TCountryCode } from 'countries-list'
import { IApplication } from './application'
import { IDocumentReference } from './document-reference'
import { IEmailNamePair } from './email-name-pair.interface'
import { IFinancialTerm } from './financial-term'
import { IOrder } from './order'
import { IUser } from './user'

// @deprecated
export enum PaymentType {
  RepaymentToEP = 'REPAYMENT_TO_EP',
  FixPayInstalment = 'FIXPAY_INSTALMENT',
  Upfront = 'UPFRONT',
  LearningBudget = 'LEARNING_BUDGET',
}

// @deprecated
export interface IPayment {
  _id?: string
  user: IUser | string
  totalAmount: number
  currency: string
  agreementFeeAmount: number
  status: PaymentStatus
  externalPaymentId?: string
  paymentMethod: PaymentMethod
  paymentSources: IDocumentReference[]
  automaticPayout: boolean
  transferred: boolean
  paymentType: PaymentType
  scheduledTo?: Date
  payer?: string
}
// @deprecated
export interface IPaymentCheckoutResponse {
  redirectUrl?: string
  applicationId?: string
  orderId?: string
}

// @deprecated
export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Pending = 'PENDING',
  Paid = 'PAID',
  Failed = 'FAILED',
}

// @deprecated
export enum PaymentFeature {
  LearningBudget = 'LEARNING-BUDGET',
  TaxBenefits = 'TAX-BENEFITS',
}

export enum CheckoutType {
  UpFront = 'UPFRONT',
  Fixpay = 'FIXPAY',
  Free = 'FREE',
  Isa = 'ISA',
  NoAgreement = 'NO_AGREEMENT',
  Fundae = 'FUNDAE',
}

// @deprecated use CheckoutSchema instead
export interface ICheckoutPayload {
  courseId: string
  cohortId: string
  type?: CheckoutType
  learningBudget?: {
    amount: number
    currency: string
  } | null
  fixedNumberOfInstalments?: number
  flexibleRemuneration?: boolean
  reviewerEmails?: IEmailNamePair[]
}

export interface INewCheckoutPayload {
  courseId: string
  cohortId: string
  paymentOptions: PaymentMethodOption[]
}

export interface INewCheckoutResponse {
  redirectUrl: string
  application: IApplication
  order: IOrder
}

// @deprecated
export interface IFixPayCheckoutPayload {
  financialProductId: string
  successUrl: string
  cancelUrl: string
}

// @deprecated
export enum PaymentFeature {
  CustomizableLearningBudget = 'CUSTOMIZABLE_LEARNING_BUDGET',
  FlexibleRemuneration = 'FLEXIBLE_REMUNERATION',
}

export enum PaymentMethod {
  Card = 'card',
  Klarna = 'klarna',
  FixPay = 'fix_pay',
  Isa = 'isa',
  LearningBudget = 'learning_budget',
  TaxBenefits = 'tax_benefits',
  Fundae = 'fundae',
  Free = 'free',
  NoAgreement = 'no_agreement',
  TaxBenefitsAndFixPay = 'tax_benefits_with_fix_pay',
}

export enum PaymentMethodMode {
  Upfront = 'upfront',
  Instalments = 'instalments',
}
export interface IISAPaymentOptionConfigurationData {
  financialTerm: IFinancialTerm
}

export interface IPaymentOptionConfiguration<
  P extends PaymentMethod,
  T extends object | undefined = undefined,
> {
  type: P
  isAvailable: boolean
  isEnquiryAvailable: boolean
  data?: T
}

// @deprecated
export enum PaymentOptions {
  UPFRONT = 'upfront',
  FIX_PAY = 'fix-pay',
  LEARNING_BUDGET_IN_FULL = 'learning-budget-in-full',
  ISA = 'isa',
  FREE_COURSE = 'free-course',
  NO_AGREEMENT = 'no-agreement',
  FUNDAE = 'fundae',
}

export type IInstalment = {
  amount: number
  currency: string
  dueDate: string
}

export interface IInstalmentInformation {
  numberOfInstalments: number
  isSimulation: boolean
  instalments: IInstalment[]
}

export interface IAvailableCountriesInfo {
  availableCountries: TCountryCode[]
}

export type IPaymentConfigurationWithInstalmentsInfo = {
  options: IInstalmentInformation[]
}

export type IFixPayPaymentConfiguration = IPaymentOptionConfiguration<
  PaymentMethod.FixPay,
  IPaymentConfigurationWithInstalmentsInfo
> &
  IAvailableCountriesInfo

export type IFreePaymentOptionConfiguration =
  IPaymentOptionConfiguration<PaymentMethod.Free>

export type IFundaePaymentOptionConfiguration =
  IPaymentOptionConfiguration<PaymentMethod.Fundae>

export type IISAPaymentOptionConfiguration = IPaymentOptionConfiguration<
  PaymentMethod.Isa,
  IISAPaymentOptionConfigurationData & IPaymentConfigurationWithInstalmentsInfo
> &
  IAvailableCountriesInfo

export type IKlarnaPaymentOptionConfiguration = IPaymentOptionConfiguration<
  PaymentMethod.Klarna,
  IPaymentConfigurationWithInstalmentsInfo
> &
  IAvailableCountriesInfo

export type ILearningBudgetPaymentOptionConfiguration =
  IPaymentOptionConfiguration<
    PaymentMethod.LearningBudget,
    {
      learningBudgetAmount: number
    }
  >

export type INoAgreementPaymentOptionConfiguration =
  IPaymentOptionConfiguration<PaymentMethod.NoAgreement>

export type ITaxBenefitsPaymentOptionConfiguration =
  IPaymentOptionConfiguration<
    PaymentMethod.TaxBenefits,
    IPaymentConfigurationWithInstalmentsInfo
  > &
    IAvailableCountriesInfo

export type ICardPaymentOptionConfiguration =
  IPaymentOptionConfiguration<PaymentMethod.Card>

export type IInstalmentPaymentOptionConfigurations =
  | IFixPayPaymentConfiguration
  | IKlarnaPaymentOptionConfiguration
  | IISAPaymentOptionConfiguration

export type IPayWithEmployerSupportPaymentOptionConfigurations =
  | IFundaePaymentOptionConfiguration
  | ILearningBudgetPaymentOptionConfiguration
  | IFixPayPaymentConfiguration
  | ITaxBenefitsPaymentOptionConfiguration

export type CheckoutPagePaymentMethodConfigurations =
  | ICardPaymentOptionConfiguration
  | IInstalmentPaymentOptionConfigurations
  | IPayWithEmployerSupportPaymentOptionConfigurations

export type AllPaymentMethodConfigurations =
  | IFixPayPaymentConfiguration
  | IKlarnaPaymentOptionConfiguration
  | IISAPaymentOptionConfiguration
  | ILearningBudgetPaymentOptionConfiguration
  | INoAgreementPaymentOptionConfiguration
  | ITaxBenefitsPaymentOptionConfiguration
  | IFundaePaymentOptionConfiguration
  | IFreePaymentOptionConfiguration
  | ICardPaymentOptionConfiguration

export type CheckoutPagePaymentMethods =
  | PaymentMethod.Card
  | PaymentMethod.FixPay
  | PaymentMethod.Klarna
  | PaymentMethod.Isa
  | PaymentMethod.Fundae
  | PaymentMethod.LearningBudget
  | PaymentMethod.TaxBenefits
  | PaymentMethod.TaxBenefitsAndFixPay

export type PaymentMethodOption = {
  type: PaymentMethod
  amount: number
  mode: PaymentMethodMode
  reviewerEmails?: Required<IEmailNamePair>[]
  numberOfInstalments?: number
}

// @deprecated
export enum PaymentOption {
  UpFront = 'UPFRONT',
  FixPay = 'FIX_PAY',
  ISA = 'ISA',
  LearningBudgetInFull = 'LEARNING_BUDGET_IN_FULL',
  Fundae = 'FUNDAE',
  Klarna = 'KLARNA',
}
